import { Box, SxProps, Typography } from '@mui/material';
import React from 'react';
import { AttachFile } from '@mui/icons-material';
import { SearchConversationsItem } from 'modules/conversations/types';

type Props = {
  attachments: SearchConversationsItem['attachments'];
  onClick: () => void;
};

const container: SxProps = {
  display: 'flex',
  direction: 'column',
  alignItems: 'center'
};

const textStyles: SxProps = {
  display: 'flex',
  direction: 'column',
  alignItems: 'center',
  textDecoration: 'underline'
};

export const Documents: React.FC<Props> = ({ attachments, onClick }) => {
  if (!attachments?.items.length) return <span>-</span>;

  return (
    <Box sx={container}>
      <Typography
        variant="body2"
        color="primary.main"
        sx={textStyles}
        onClick={onClick}
        component="a"
      >
        {attachments.items.length}
        <AttachFile color="primary" sx={{ fontSize: '20px' }} />
      </Typography>
    </Box>
  );
};
